import { useCallback } from 'react';

import type { UserEngagementScoreIncrement_Source } from '#src/protos/webview/channel/native_messages.ts';

import { useIsMobileApp } from './useIsMobileApp.ts';

export const useSendUserEngagementIncrement = () => {
  const { isMobileApp, postMessage } = useIsMobileApp();

  const sendUserEngagementIncrement = useCallback(
    (score: number, source: UserEngagementScoreIncrement_Source) => {
      if (isMobileApp && score)
        postMessage('userEngagementScoreIncrement', {
          score,
          source,
        });
    },
    [isMobileApp, postMessage]
  );

  return {
    sendUserEngagementIncrement,
  };
};
